module.exports = __webpack_public_path__ + "static/media/contact-phone.faf2b279.svg";